import { useState, useEffect  } from 'react';
import "react-datepicker/dist/react-datepicker.css";
import calender from "../../assets/images/calender.png";
import moment from 'moment';
import axiosInstance from '../../helpers/axios';
import TopCards from './Card';
import Datetime from 'react-datetime';
import { useSelector } from 'react-redux';
import {
  Grid,
  Paper,
  TableContainer,
  Typography, TablePagination
} from '@mui/material';


export default function Mandatepresentdata() {
    const [startDate, setStartDate] = useState(null);
    const [actaulStartDate,setActualStartDate] = useState('');
    const [isLoading, setIsLoading] = useState(false);  
    const [cardData,setCardsData] = useState('');
    const [data, setData] = useState([]);
    const [instiData, setInstiData] = useState([]);
    const user = null;
    const [pagination, setPagination] = useState({
      currentPage: 1,
      perPage: 10
    });
  const productTypeSelected = useSelector((state) => state.ProductTypeFilter.selectedProductType);
     const [paginationInst, setPaginationInst] = useState({
      currentPageInst: 1,
      perPageInst: 10
    });

      const url1 = "/loan-repayment/bounce-analytics/presented-mandates";
      const url2 = "/loan-repayment/bounce-analytics/institute/mandates";
      const url3 = "/loan-repayment/bounce-analytics/bank/mandates";

      const headers = {
      };
      



    
const fetchingData = ()=>{
     
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const year = today.getFullYear();
  const month = today.getMonth();
  const fixedDays = [1, 5, 10, 15, 20];

  let lastCompletedDate = null;
  for (let i = fixedDays.length - 1; i >= 0; i--) {
    const d = new Date(year, month, fixedDays[i]);
    d.setHours(0, 0, 0, 0);
    if (d <= today) {
      lastCompletedDate = d;
      break;
    }
  }

  if (!lastCompletedDate) {
    lastCompletedDate = new Date(year, month - 1, 20);
  }

  // 👉 Define the formatter function as a const inside useEffect
  const formatDateToYYYYMMDD = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };
   const neardate=formatDateToYYYYMMDD(lastCompletedDate)
  setStartDate(formatDateToYYYYMMDD(lastCompletedDate));


 
    const formattedActualStartDate =  moment(actaulStartDate!=="Invalid date"?actaulStartDate:'', 'DD MMM YYYY').format('YYYY-MM-DD');



    let queryParamsForCards = {}
    if(actaulStartDate){
      queryParamsForCards.duedate =actaulStartDate 
    }else{
      queryParamsForCards.duedate =neardate 
    }
  if (productTypeSelected && productTypeSelected !== "all") {
    queryParamsForCards.loanType = Number(productTypeSelected);
  }


    let queryParams = {}
    if(pagination.currentPage){
      queryParams.pageNo = pagination.currentPage
    }
  
    if(pagination.perPage){
      queryParams.perPage = pagination.perPage
    }
    if(actaulStartDate){
      queryParams.duedate =actaulStartDate 
    }else{
      queryParams.duedate =neardate 
    }
  if (productTypeSelected && productTypeSelected !== "all") {
    queryParams.loanType = Number(productTypeSelected);
  }
    let queryParamsinst ={}
    if(paginationInst.currentPageInst){
      queryParamsinst.pageNo = paginationInst.currentPageInst
    }
  
    if(paginationInst.perPageInst){
      queryParamsinst.perPage = paginationInst.perPageInst
    }
    if(actaulStartDate){
      queryParamsinst.duedate =actaulStartDate 
    }else{
      queryParamsinst.duedate =neardate 
    }
  if (productTypeSelected && productTypeSelected !== "all") {
    queryParamsinst.loanType = Number(productTypeSelected);
  }
      // Call all three APIs in parallel
      Promise.all([
        axiosInstance.get(url1, { params: queryParamsForCards , headers }),
        axiosInstance.get(url2, { params: queryParamsinst , headers }),
        axiosInstance.get(url3, {
          params: queryParams,
          headers,
        })
      ])
        .then(([res1, res2, res3]) => {
          setCardsData(res1?.data?.data)
          setInstiData(res2?.data?.data?.data); 
          setPaginationInst(res2?.data?.data?.pagination);
          setData(res3?.data?.data?.banks); // array of rows
         setPagination(res3?.data?.data?.pagination);

      
          setTimeout(() => {
            setIsLoading(false);
          }, 300);
        })
        .catch((error) => {
          alert(error?.response?.data?.message || "Error fetching data");
          console.error("Error in one of the API calls:", error);
        });




}

  

   useEffect(() => {
 
    fetchingData(pagination.currentPage, pagination.perPage);


   }, [productTypeSelected]);

const handleChangePage = (event, newPage) => {
 
  const updatedPage = newPage + 1;
  // fetchingData(newPage + 1, pagination.perPage); // API is 1-indexed
  const formattedActualStartDate =  moment(actaulStartDate!=="Invalid date"?actaulStartDate:'', 'DD MMM YYYY').format('YYYY-MM-DD');
  let queryParams ={}
  if(newPage){
    queryParams.pageNo = updatedPage
  }

  if(pagination.perPage){
    queryParams.perPage = pagination.perPage
  }
  if(actaulStartDate){
    queryParams.duedate =actaulStartDate 
  }else{
    queryParams.duedate =startDate 
  }
  if (productTypeSelected && productTypeSelected !== "all") {
    queryParams.loanType = Number(productTypeSelected);
  }
  axiosInstance.get(url3, { params:  queryParams , headers })
  .then((res3) => {
    setData(res3?.data?.data?.banks); // array of rows
    setPagination(res3?.data?.data?.pagination);
    setTimeout(() => {
      setIsLoading(false);
    }, 300);
  })
  .catch((error) => {
    alert(error?.response?.data?.message || "Error fetching data");
    console.error("Error in one of the API calls:", error);
  });




};

const handleChangeRowsPerPage = (event,newPage) => {
  const newPerPage = parseInt(event.target.value, 10);
  // fetchingData(1, newPerPage); // Reset to page 1

  const formattedActualStartDate =  moment(actaulStartDate!=="Invalid date"?actaulStartDate:'', 'DD MMM YYYY').format('YYYY-MM-DD');

  let queryParams ={}

  if(pagination.pageNo){
    queryParams.pageNo = pagination.pageNo
  }

  if(newPerPage){
    queryParams.perPage = newPerPage
  }
  if(actaulStartDate){
    queryParams.duedate =actaulStartDate 
  }else{
    queryParams.duedate =startDate 
  }
  if (productTypeSelected && productTypeSelected !== "all") {
    queryParams.loanType = Number(productTypeSelected);
  }

  axiosInstance.get(url3, { params:  queryParams , headers })
  .then((res3) => {
    setData(res3?.data?.data?.banks); // array of rows
    setPagination(res3?.data?.data?.pagination);
   

    setTimeout(() => {
      setIsLoading(false);
    }, 300);
  })
  .catch((error) => {
    alert(error?.response?.data?.message || "Error fetching data");
    console.error("Error in one of the API calls:", error);
  });



};


const handleChangePageinst = async (event, newPage) => {
  const newPerPage = parseInt(event.target.value, 10);
  const updatedPage = newPage + 1;
  const formattedActualStartDate =  moment(actaulStartDate!=="Invalid date"?actaulStartDate:'', 'DD MMM YYYY').format('YYYY-MM-DD');

  let queryParams ={}
  if(newPage){
    queryParams.pageNo = updatedPage 
  }

  if(paginationInst.perPageInst){
    queryParams.perPage = paginationInst.perPageInst
  }
  if(actaulStartDate){
    queryParams.duedate =actaulStartDate 
  }else{
    queryParams.duedate =startDate 
  }

  if (productTypeSelected && productTypeSelected !== "all") {
    queryParams.loanType = Number(productTypeSelected);
  }
  const res2 = await axiosInstance.get(url2, {
    params: queryParams,
    headers,
  });
  setInstiData(res2?.data?.data?.data); // array of rows
  setPaginationInst(res2?.data?.data?.pagination);

};

const handleChangeRowsPerPageinst = (event,newPage) => {
  const newPerPage = parseInt(event.target.value, 10);
  // fetchingData(1, newPerPage); // Reset to page 1
 
  const formattedActualStartDate =  moment(actaulStartDate!=="Invalid date"?actaulStartDate:'', 'DD MMM YYYY').format('YYYY-MM-DD');

  let queryParams ={}

  if(paginationInst.currentPageInst){
    queryParams.pageNo = paginationInst.currentPageInst
  }

  if(newPerPage){
    queryParams.perPage = newPerPage
  }
  if(actaulStartDate){
    queryParams.duedate =actaulStartDate 
  }else{
    queryParams.duedate =startDate 
  }
  if (productTypeSelected && productTypeSelected !== "all") {
    queryParams.loanType = Number(productTypeSelected);
  }
  axiosInstance.get(url2, { params:  queryParams , headers })
  .then((res2) => {
    setInstiData(res2?.data?.data?.data); // array of rows
    setPaginationInst(res2?.data?.data?.pagination);
   

    setTimeout(() => {
      setIsLoading(false);
    }, 300);
  })
  .catch((error) => {
    alert(error?.response?.data?.message || "Error fetching data");
    console.error("Error in one of the API calls:", error);
  });


};


    
// 


  return (
      <div style={{width:"100%",backgroundColor:'white',height:'130%'}}>

    <div style={{display:'flex',marginTop:'2em'}}>
      {/* <DatePicker
        selected={actaulStartDate}
        customInput={
            <input
              style={{
                height: "33px",
                fontSize: "14px",
                borderRadius: "2px",
                border: "1px solid #ccc",
                textAlign: "center",
                backgroundImage: `url(${calender})`,
                backgroundRepeat: "no-repeat",
                backgroundPosition: "10px center",
                backgroundSize: "15px 15px",
                paddingLeft: "20px",
              
              }}

            
              readOnly
            />}
        placeholder="Select date range"
        allowClear={true}
        format="DD MMM YYYY"
        onChange={(date) => {
          setActualStartDate(date);
        }}
        dateFormat="yyyy-MM-dd"
        placeholderText="Select date"
      /> */}





  <Datetime
        closeOnSelect={false}
        dateFormat="YYYY-MM-DD" // Change to desired format
        timeFormat={false}
        onChange={(event) => {
          if (event && event.format) {
            setActualStartDate(event.format("YYYY-MM-DD"));
          } else {
            setActualStartDate("");
          }
        }}
        locale="en-gb"
        inputProps={{
          placeholder: "Select mandate date",
          style: {
            height: "33px",
            fontFamily: "Inter-Medium",
            backgroundImage: `url(${calender})`,
            backgroundRepeat: "no-repeat",
            backgroundPosition: "5px center",
            backgroundSize: "15px 15px",
            paddingLeft: "30px",
            fontSize: "14px",
            border: "1px solid #ccc",
            borderRadius: "4px",
            width: "100%",
            marginTop:'5px'
          },
          value: actaulStartDate, // Ensure the value is synced with the state
        }}
      />






    <button style={{display: 'flex', alignItems: 'center',width:'130px',backgroundColor:'#D22129',height:'34px',borderStyle:'none',borderRadius:"5px",color:'white',fontFamily:"Inter-Medium",paddingLeft:'10px', marginLeft:'30px',marginTop:'5px'}}
             onClick={() => fetchingData()}
             >
               Search Results
             </button>

             </div>

             <div style={{marginTop:'2em'}}>
             <TopCards CardData={cardData} />
             </div>


             <Grid container spacing={2}  style={{marginTop:'2em'}}>
      {/* Table 1 */}
      <Grid item xs={12} md={6}>
        <TableContainer component={Paper}>
          <Typography variant="h6" align="center" p={1}>
            Institutes
          </Typography>
          <table className='tables'>
      <thead className='table-heading' >
            <tr>
              <th style={{ fontSize: '14px', cursor: 'pointer', width: '30em', fontFamily: "Inter-Medium" }}>Inst.Name</th>
              <th style={{ fontSize: '14px', cursor: 'pointer', width: '20em', fontFamily: "Inter-Medium"}}>Presented</th>
              <th style={{ fontSize: '14px', cursor: 'pointer', width: '20em', fontFamily: "Inter-Medium"}}>Success</th>
              <th style={{ fontSize: '14px', cursor: 'pointer', width: '20em', fontFamily: "Inter-Medium" }}>Insuf.fund</th>
              <th style={{ fontSize: '14px', cursor: 'pointer', width: '20em', fontFamily: "Inter-Medium"  }}>Tech.Issues</th>
             

         
            </tr>
          </thead>
        <tbody className="table-body">
        {instiData?.map((item, index) => (
             <tr className="table-row"  key={index} style={{ lineHeight:"25px" ,cursor: "pointer"}}
             >
                <td title={item.instituteName} style={{color:'#667085',fontFamily:'Inter',fontSize:'14px',fontWeight:'500',maxWidth:'12em'}}><span style={{fontFamily:'Inter',fontSize:'14px',fontWeight:'500',color:'#667085',fontWeight:'500',lineHeight:'1.5em',display:'block',whiteSpace:'nowrap',overflow:'hidden',textOverflow:'ellipsis',cursor:'pointer',color:'#101828',fontWeight:'500'}} >{item?.instituteName?.toLowerCase().split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')}</span></td>
               <td style={{ fontSize: '14px', cursor: 'pointer', width: '10em', fontFamily: "Inter-Medium", color: '#667085' }}>{item.presentedCount?item.presentedCount:"-"}</td>
               <td style={{ fontSize: '14px', cursor: 'pointer', width: '10em', fontFamily: "Inter-Medium", color: '#667085' }}>{item.successCount?item.successCount:"-"}</td>
               <td style={{ fontSize: '14px', cursor: 'pointer', width: '10em', fontFamily: "Inter-Medium", color: '#667085' }}>{item.insufficientCount?item.insufficientCount:"-"}</td>
               <td style={{ fontSize: '14px', cursor: 'pointer', width: '7em', fontFamily: "Inter-Medium", color: '#667085' }}>{item.otherFailureCount?item.otherFailureCount:"-"}</td>
               
              
             </tr>
            ))}
        </tbody>
      </table>
      <div>
      
   <TablePagination
  component="div"
  count={paginationInst?.totalItems || 0}
  page={(paginationInst?.currentPage || 1) - 1} // MUI is 0-indexed
  onPageChange={handleChangePageinst}
  rowsPerPage={paginationInst?.perPage || 10}
  onRowsPerPageChange={handleChangeRowsPerPageinst}
  rowsPerPageOptions={[5, 10, 25, 50]}
  sx={{
    "& .MuiTablePagination-select": { marginBottom: "10px" },
    "& .MuiIconButton-root": {
      marginBottom: '10px' 
    }
  }}
/>

    </div>

        </TableContainer>
    
      </Grid>

      {/* Table 2 */}
      <Grid item xs={12} md={6}>
        <TableContainer component={Paper}>
          <Typography variant="h6" align="center" p={1}>
          Banks
          </Typography>
          <table className='tables'>
      <thead className='table-heading' >
            <tr>
            <th style={{ fontSize: '14px', cursor: 'pointer', width: '30em', fontFamily: "Inter-Medium" }}>Bank Name</th>
            <th style={{ fontSize: '14px', cursor: 'pointer', width: '20em', fontFamily: "Inter-Medium"}}>Presented</th>
              <th style={{ fontSize: '14px', cursor: 'pointer', width: '20em', fontFamily: "Inter-Medium"}}>Success</th>
              <th style={{ fontSize: '14px', cursor: 'pointer', width: '20em', fontFamily: "Inter-Medium" }}>Insuf.fund</th>
              <th style={{ fontSize: '14px', cursor: 'pointer', width: '20em', fontFamily: "Inter-Medium"  }}>Tech.Issues</th>
           
            
            </tr>
          </thead>
        <tbody className="table-body">
        {data?.map((item, index) => (
             <tr className="table-row"  key={index} style={{ lineHeight:"25px" ,cursor: "pointer"}}>
               <td  title={item.bank_name} style={{ fontSize: '14px', cursor: 'pointer', width: '10em', fontFamily: "Inter-Medium", color: '#667085', paddingLeft: '10px', whiteSpace: 'nowrap',overflow: 'hidden',textOverflow: 'ellipsis' }}>{item.bank_name?item.bank_name:"-"}</td>
               <td style={{ fontSize: '14px', cursor: 'pointer', width: '10em', fontFamily: "Inter-Medium", color: '#667085' }}>{item.presentedCount?item.presentedCount:"-"}</td>
               <td style={{ fontSize: '14px', cursor: 'pointer', width: '10em', fontFamily: "Inter-Medium", color: '#667085' }}>{item.successCount?item.successCount:"-"}</td>
               <td style={{ fontSize: '14px', cursor: 'pointer', width: '10em', fontFamily: "Inter-Medium", color: '#667085' }}>{item.insufficientCount?item.insufficientCount:"-"}</td>
               <td style={{ fontSize: '14px', cursor: 'pointer', width: '7em', fontFamily: "Inter-Medium", color: '#667085' }}>{item.otherFailureCount?item.otherFailureCount:"-"}</td>
        
             </tr>
    ))}
        </tbody>
      </table>
   <div>
   <TablePagination
  component="div"
  count={pagination?.totalItems || 0}
  page={(pagination?.pageNo || 1) - 1} // MUI is 0-indexed
  onPageChange={handleChangePage}
  rowsPerPage={pagination?.perPage || 10}
  onRowsPerPageChange={handleChangeRowsPerPage}
  rowsPerPageOptions={[5, 10, 25, 50]}
  sx={{
    "& .MuiTablePagination-select": { marginBottom: "10px" },
    "& .MuiIconButton-root": {
      marginBottom: '10px' /* Adjust the bottom margin */
    }
  }}
/>
    </div>
        </TableContainer>
      </Grid>
    </Grid>

    </div>
  )
}
